import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import { Typography, Grid } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Link from "@material-ui/core/Link";
import { DocumentsComponent } from "./DocumentsComponent";
import iconHabitation from "assets/images/icon_habitation.svg";
import iconSanteMob from "assets/images/icon_sante-mob.svg";
import iconRc from "assets/images/icon_RC.svg";
import iconMultimedia from "assets/images/icon_multimedia.svg";

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    marginTop: theme.spacing(4),
  },
  wrapIcon: {
    verticalAlign: "middle",
    display: "inline-flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
    width: "100%",
    fontWeight: "bold",
    color: "black",
  },
  titleIcon: {
    width: 36,
    height: 36,
    marginRight: theme.spacing(1),
  },
  yearText: {
    textTransform: "uppercase",
    marginTop: "1%",
  },
  filterTextTypo: {
    marginTop: "1%",
  },
  filterLink: {
    color: "#040f89",
  },
  formControl: {
    margin: "0px 8px 8px 8px",
    minWidth: 120,
  },
}));

export const DocumentsSection = (props) => {
  const { documents, type } = props;
  const classes = useStyles();
  const { t } = useTranslation("common");

  const [selectedYear, setSelectedYear] = useState("");
  const [docYears, setDocYears] = useState([]);
  const [orderedDocs, setOrderedDocs] = useState([]);

  const handleYearFilterChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const resetYearFilter = () => {
    setSelectedYear("");
  };

  function removeDuplicates(data) {
    return data.filter((value, index) => data.indexOf(value) == index);
  }

  const renderTitle = (iconSrc, alt, labelKey) => (
    <Typography
      className={classes.wrapIcon}
      style={{ textTransform: "uppercase" }}
      variant="h4"
    >
      <img src={iconSrc} alt={alt} className={classes.titleIcon} />
      {t(labelKey)}
    </Typography>
  );

  const getTitle = () => ({
    sM: renderTitle(iconSanteMob, "health", "docs.health.title"),
    h: renderTitle(iconHabitation, "home", "docs.home.title"),
    m: renderTitle(iconMultimedia, "multimedia", "docs.multimedia.title"),
    rc: renderTitle(iconRc, "rc", "docs.rc.title"),
  });

  useEffect(() => {
    let years = [];
    documents.map((item, i) => {
      let year = item.createdAt.split("/");
      years.push(year[2]);
    });
    let properYears = removeDuplicates(years);
    setDocYears(properYears);

    let doc = {};
    let docs = [];
    documents.map((item, i) => {
      let createdYear = item.createdAt.split("/");
      doc = {
        name: item.document !== undefined ? item.document.fileName : "",
        year: createdYear[2],
        contractId: item.id,
        documentType: item.documentType,
        documentId: item.document !== undefined ? item.document.id : "",
      };
      docs.push(doc);
    });
    setOrderedDocs(docs);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        align="center"
        justify="center"
        alignItems="center"
        className={classes.contentContainer}
      >
        {getTitle()[type]}
      </Grid>
      <Grid item xs={6} container direction="row">
        <Typography className={classes.yearText} variant="h6">
          {t("docs.year")} {" :"}
        </Typography>
        <FormControl className={classes.formControl}>
          <Select
            value={selectedYear}
            onChange={handleYearFilterChange}
            displayEmpty
            className={classes.selectEmpty}
            inputProps={{ "aria-label": "Year" }}
          >
            <MenuItem value="">
              <em>Toutes</em>
            </MenuItem>
            {docYears.map((item, i) => (
              <MenuItem key={i} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography className={classes.filterTextTypo}>
          <Link
            href="#"
            onClick={resetYearFilter}
            variant="body2"
            className={classes.filterLink}
          >
            {t("docs.filter")}
          </Link>
        </Typography>
      </Grid>
      <Grid item xs={12} container direction="row">
        {selectedYear ? (
          <DocumentsComponent
            documents={orderedDocs.filter((doc) => doc.year === selectedYear)}
            year={selectedYear}
          />
        ) : (
          docYears.map((item, i) => (
            <DocumentsComponent
              key={i}
              documents={orderedDocs.filter((doc) => doc.year === item)}
              year={item}
            />
          ))
        )}
      </Grid>
    </Grid>
  );
};
